
export default function Loading(){

    const loadingStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        color: 'white',
        fontSize: '30px',
        fontWeight: 'bold',
        zIndex: 1000            
    }      

    return (
        <div className="loading" style={loadingStyle}>
            로딩중..
        </div>
    );
}

